import { create } from 'zustand';

import User from 'core/models/user';

// État d'UI « session » (utilisateur courant + visibilité de la modale d'essai).
// C'est de l'état client pur, donc il vit dans un store zustand plutôt que dans
// Redux. Remplace l'ancien morceau Redux `state.session` + les actions
// SET_SESSION_USER / LOGIN_SESSION_USER / CLEAR_SESSION_USER / CLOSE_TRIAL_MODAL
// (cf. core/useCases/session/{reducer,logInAction,logOutAction,types}.ts).
interface SessionState {
    // Reprend la forme exacte de l'ancien state.
    user: User | null;
    trialModalVisible: boolean;
    // Remplace dispatch(setSessionUserAction(user)) :
    // pose l'utilisateur et masque la modale d'essai (cas SET_SESSION_USER).
    setUser: (user: User) => void;
    // Remplace dispatch(loginSessionUserAction(user)) :
    // pose l'utilisateur et affiche la modale d'essai (cas LOGIN_SESSION_USER).
    login: (user: User) => void;
    // Remplace dispatch(clearSessionUserAction()) :
    // remet le store à son état initial (cas CLEAR_SESSION_USER).
    logout: () => void;
    // Remplace dispatch(closeTrialModalAction()) (cas CLOSE_TRIAL_MODAL).
    closeTrialModal: () => void;
}

// État initial, identique à l'ancien `init` du reducer.
const initialState = {
    trialModalVisible: false,
    user: null,
};

export const useSessionStore = create<SessionState>((set) => ({
    ...initialState,
    setUser: (user) => set({ trialModalVisible: false, user }),
    login: (user) => set({ trialModalVisible: true, user }),
    logout: () => set({ ...initialState }),
    closeTrialModal: () => set({ trialModalVisible: false }),
}));
